import { useState, useCallback, useEffect } from 'react';

/**
 * Hook to detect whether CapsLock is currently active
 * @returns boolean indicating if CapsLock is on
 */
export const useCapsLockDetection = (): boolean => {
  const [isCapsLockOn, setIsCapsLockOn] = useState(false);

  // Handle key events to detect CapsLock state
  const handleKeyEvent = useCallback((event: KeyboardEvent) => {
    if (event.getModifierState) {
      setIsCapsLockOn(event.getModifierState('CapsLock'));
    }
  }, []);

  // Add event listeners on hook mount
  useEffect(() => {
    window.addEventListener('keydown', handleKeyEvent);
    window.addEventListener('keyup', handleKeyEvent);

    // Cleanup on unmount
    return () => {
      window.removeEventListener('keydown', handleKeyEvent);
      window.removeEventListener('keyup', handleKeyEvent);
    };
  }, [handleKeyEvent]);

  return isCapsLockOn;
};
